import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { SvgIconEl } from 'common/components/svg-icon';
import { ButtonTheme } from '../button/constants';
export function template() {
  return jsx("div", {
    sel: '.banner-wrapper',
    class: {
      ["".concat(this.attr("theme"), "-theme")]: true,
      ["".concat(this.attr("type"), "-type")]: true
    }
  }, jsx("div", {
    sel: '.banner-panel',
    class: {
      ["".concat(this.attr("size"), "-size")]: true,
      ["".concat(this.attr("theme"), "-theme")]: true,
      ["".concat(this.attr("type"), "-type")]: true,
      'body-only': this.attr("body-text") && !this.attr("header-text")
    }
  }, this.helpers.getIcon() ? jsx(SvgIconEl, {
    sel: '.banner-title-icon',
    attrs: {
      icon: this.helpers.getIcon()
    },
    class: {
      'banner-copy-no-header': !this.attr("header-text")
    }
  }) : null, jsx("div", {
    sel: '.banner-content'
  }, jsx("div", {
    sel: '.banner-copy',
    class: {
      'banner-copy-no-header': !this.attr("header-text")
    }
  }, this.attr("header-text") ? jsx("header", {
    sel: '.banner-header'
  }, this.attr("header-text")) : null, this.attr("body-text") ? this.helpers.formatText(this.attr("body-text"), {
    className: "banner-body"
  }) : null), this.attr("ctas") && this.attr("ctas").length > 0 ? jsx("div", {
    sel: '.banner-actions'
  }, this.attr("ctas").map(cta => {
    const isEmbedded = this.attr("type") === this.helpers.BannerType.Embedded;
    const shownTheme = isEmbedded ? ButtonTheme.Secondary : cta.theme || ButtonTheme.Secondary;
    const shouldShowXIcon = this.attr("size") === this.helpers.BannerSize.Small && cta.actionName === this.helpers.BannerAction.Dismiss;
    return jsx(ButtonEl, {
      sel: '.cta-button',
      attrs: {
        theme: shownTheme,
        icon: shouldShowXIcon ? "x" : cta.icon,
        type: this.helpers.getButtonType()
      },
      class: {
        'banner-action-button-embedded': isEmbedded,
        ["".concat(this.attr("theme"), "-theme")]: true
      },
      on: {
        click: () => this.helpers.handleCtaButtonClick(cta)
      }
    }, !shouldShowXIcon ? cta.text : null);
  })) : null)));
}